import Vue from 'vue'

// 业务常用组件抽象类
import navcomp from "@/components/common/nav"
import footercomp from "@/components/common/footer"
import announceBar from "@/components/common/announceBar"
import agreement from "@/components/common/agreement"
import personal from "@/components/common/personal"
import discountInput from "@/components/common/discountInput"
import progressBar from '@/components/common/progress'
import discountModal from '@/components/common/discountModal'
import certification from '@/components/common/certification'

let componentsArray = [
    { name: 'nav-comp', instance: navcomp },
    { name: 'footer-comp', instance: footercomp },
    { name: 'announce-bar', instance: announceBar },
    { name: 'agreement', instance: agreement },
    { name: 'personal', instance: personal },
    { name: 'discount-input', instance: discountInput },
    { name: 'progress-bar', instance: progressBar },
    { name: 'discount-modal', instance: discountModal },
    { name: 'certification', instance: certification },
]

componentsArray.forEach(component => {
    Vue.component(component.name, component.instance)
})


// WEBPACK FOOTER //
// ./src/utils/components.js